import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const testimonials = [
    {
        // image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Shelly Thompson',
        position: 'Project Manager',
        review: 'QTO International provided exceptional takeoff services for our commercial project. Their accuracy and efficiency helped us stay on schedule and within budget. Highly recommended!'
    },
    {
        // image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Cuthbert Brain',
        position: 'Construction Coordinator',
        review: 'Working with QTO International has been a game-changer for our team. Their precise cost estimations and quick turnaround times make them an invaluable partner!'
    },
    {
        // image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Cathrine Wagner',
        position: 'General Contractor',
        review: 'QTO International’s expertise in quantity takeoffs saved us both time and money. Their attention to detail and customer-focused approach were key to our projects success!'
    },
    {
        // image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Emily Johnson',
        position: 'Senior Estimator',
        review: 'The quality of their takeoff reports is unmatched. We trust QTO International to handle all our large-scale projects—they always deliver reliable results!'
    },
    {
        // image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Robert Harris',
        position: 'General Contractor',
        review: 'QTO International’s services are top-notch. Their comprehensive takeoffs allowed us to move forward with confidence, knowing we had accurate data every step of the way!'
    }
]

var bnr1 = require('./../../images/background/bg6.jpg');

class Testimonials extends React.Component {
    render() {

        const options = {
            loop:true,
            autoplay:true,
            margin:30,
            nav:false,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive:{
                0:{
                    items:1
                },
                991:{
                    items:2
                }
            }
        };

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b50 square_shape2 bg-cover" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Client</span> Testimonials</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* TESTIMONIAL START */}
                            <OwlCarousel className="owl-carousel testimonial-home" {...options}>
                            
                                {testimonials.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="testimonial-2 m-a30 hover-animation-1">
                                            <div className=" block-shadow bg-white p-a30">
                                                <div className="testimonial-detail clearfix">
                                                    {/* <div className="testimonial-pic radius shadow scale-in-center"><img src={item.image} width={100} height={100} alt=""/></div> */}
                                                 
                                                    <h4 className="testimonial-name m-b5">{item.reviewername} -</h4>
                                                    <span className="testimonial-position">{item.position}</span>
                                                </div>
                                                <div className="testimonial-text">
                                                    <span className="fa fa-quote-right" />
                                                    <p> {item.review}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>    
                               
                            
                        </div>
                    </div>
                    {/* <div className="hilite-title text-left p-l50 text-uppercase text-pop-up-top">
                        <strong>Clients</strong>
                    </div> */}
                </div>
            </>
        );
    }
};

export default Testimonials;